import { Modal } from '@mantine/core'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import BillingAddressModal from '@/components/make-booking/checkout/modals/BillingAddressModal'

export const Route = createFileRoute('/make-booking/$id/checkout/billing')({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  return (
    <Modal
      opened
      onClose={() => router.history.back()}
      title="Billing Address"
      centered
      classNames={{
        title: '!text-[22px] !font-bold',
        content: '!p-5',
      }}
      size="xl"
    >
      <BillingAddressModal onClose={() => router.history.back()} />
    </Modal>
  )
}
